import React from 'react';
import NewBaseTable from 'components/NewBaseTable/NewBaseTable';
import { OrderTableWrapper } from './NewSFOrdersTableStyled';
import { SFOrderHistory } from 'types';
import { generateColumnConfigs } from './OrderUtility';
import { Pagination } from 'components';
import { ITEMS_PER_PAGE } from '.';
interface Props {
  sfOrders: SFOrderHistory[];
  addItemsToCart: (order: SFOrderHistory) => void;
  showOrderModal: (order: SFOrderHistory) => void;
  formatPODate: (date: string) => string;
  t: (key: string) => string;
  updateTableOnFilterChange: (filter: string) => void;
  isDataFetching: boolean;
  totalRecords: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}
const defaultSortState = {
  id: 'startTime',
  desc: true
};
const OrderHistory = ({
  sfOrders,
  addItemsToCart,
  showOrderModal,
  formatPODate,
  t,
  updateTableOnFilterChange,
  isDataFetching,
  totalRecords,
  currentPage,
  setCurrentPage
}: Props): JSX.Element => {
  const [showPagination, setShowPagination] = React.useState(true);
  const updateSearchValue = (inputValue?: string) => {
    if (inputValue && inputValue.length > 0) {
      setShowPagination(false);
      return;
    } else {
      setShowPagination(true);
    }
  };
  return (
    <>
      <OrderTableWrapper>
        <NewBaseTable
          newTableData={sfOrders as SFOrderHistory[]}
          columnConfigs={generateColumnConfigs({
            addItemsToCart,
            showOrderModal,
            formatPODate,
            t
          })}
          sortState={defaultSortState}
          enableFilter={true}
          isShowGlobalSearch={true}
          isShowColumnOptions={true}
          handleFilterRequest={updateTableOnFilterChange}
          isDataLoading={isDataFetching}
          tdMarginLeft="0.625rem"
          textAlign="left"
          searchInputValue={updateSearchValue}
        />
      </OrderTableWrapper>
      {showPagination && sfOrders && sfOrders.length > 0 && (
        <Pagination
          onPageChange={(page) => setCurrentPage(page)}
          itemsPerPage={ITEMS_PER_PAGE}
          numItems={totalRecords}
          currentPage={currentPage}
        />
      )}
    </>
  );
};

export default OrderHistory;
